import { render } from "./AddressAutocomplete.vue?vue&type=template&id=5a867006&ts=true"
import script from "./AddressAutocomplete.ts?vue&type=script&lang=ts"
export * from "./AddressAutocomplete.ts?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__